module.exports = __webpack_public_path__ + "static/media/stjohns.8bf58b4b.png";